import {
  SR_CONTRACT_START,
  SR_CONTRACT_END,
  SR_CONTRACT_BY_ID,
  SR_TYPE_CONFIG_DATA,
  SR_TYPE_CONFIG_DATA_ID,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const SRTypes = (type, data) => ({ type, data });

// ─── Contract CRUD ────────────────────────────────────────────────────────────

export const getManufacturerChargebackContract = (id, isPendingContract) => {
  return (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    getManufacturerChargebackContractAPI(id, isPendingContract)
      .then((response) => {
        dispatch(SRTypes(SR_CONTRACT_BY_ID, response.data.response));
        dispatch(SRTypes(SR_CONTRACT_END));
      })
      .catch(() => dispatch(SRTypes(SR_CONTRACT_END)));
  };
};

const getManufacturerChargebackContractAPI = (id, isPendingContract) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  const BASE_API = '/manufacturer-chargeback/contract';
  const url = isPendingContract ? `${BASE_API}/${id}?is_pending_contract=true` : `${BASE_API}/${id}`;
  return axios.get(url, { headers });
};

export const submitManufacturerChargebackContract = (type, id, data) => {
  return async (dispatch, getState) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await submitManufacturerChargebackContractAPI(type, id, data);
      dispatch(SRTypes(SR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      throw error;
    }
  };
};

const submitManufacturerChargebackContractAPI = (type, id, data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'edit') return axios.put('/manufacturer-chargeback/contract', data, { headers });
  return axios.post('/manufacturer-chargeback/contract', data, { headers });
};

export const deleteManufacturerChargebackContract = (id) => {
  return async (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    try {
      const response = await deleteManufacturerChargebackContractAPI(id);
      dispatch(SRTypes(SR_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(SRTypes(SR_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) await handleExecutionLog(dispatch, logNumber);
      throw error;
    }
  };
};

const deleteManufacturerChargebackContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.delete(`/manufacturer-chargeback/contract/${id}`, { headers });
};

// ─── Type Config ──────────────────────────────────────────────────────────────

export const getManufacturerChargebackTypeConfig = (id, param) => {
  return (dispatch) => {
    dispatch(SRTypes(SR_CONTRACT_START));
    getManufacturerChargebackTypeConfigAPI(id, param)
      .then((response) => {
        if (id || param)
          dispatch(SRTypes(SR_TYPE_CONFIG_DATA_ID, response.data.response));
        else
          dispatch(SRTypes(SR_TYPE_CONFIG_DATA, response.data.response));
        dispatch(SRTypes(SR_CONTRACT_END));
      })
      .catch(() => dispatch(SRTypes(SR_CONTRACT_END)));
  };
};

const getManufacturerChargebackTypeConfigAPI = (id, param) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (id) return axios.get(`/config/compliance-type/${id}`, { headers });
  if (param) return axios.get('/config/compliance-type', { headers, params: param });
  return axios.get('/config/compliance-type', { headers });
};
